export function secondsToMinutes(totalSeconds) {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes.toString()}:${Math.floor(seconds).toString()}`;
}